import { all } from "redux-saga/effects";
import { getCustFullProfileWatcher,updateCustFullProfileWatcher, getProgressSummaryWatcher, getProgressHistoryWatcher, updateProgressEntryWatcher, deleteProgressEntryWatcher, getMedicalHistoryWatcher, updateMedicalHistoryWatcher, getReportsWatcher, deleteReportWatcher, getFoodLifestyleWatcher, updateFoodLifestyleWatcher, getRecallWatcher, updateRecallWatcher, getActivityByDateWatcher, setActivityGoalWatcher, getFirstLastMeasureWatcher, getAllMeasuresWatcher, deleteMeasureByIdWatcher, getBodyStartedCurrentWatcher, getAllBodyMeasuresWatcher, deleteBodyMeasureByIdWatcher, getAllLeadsWatcher, getAllCustomersWatcher, getClustersWatcher, getPractitionersWatcher, getClinicsWatcher, getTagsWatcher, getCountriesWatcher, getStatesWatcher, getCitiesWatcher, getCuisinesWatcher, getDietWatcher, uploadProgramImageWatcher, uploadImageWatcher, createProgramWatcher, getProgramEnrolledUsersWatcher, getSessionBookedUsersWatcher, getCustomerFoodLogsWatcher, getCustomerHistoryWatcher, getProgramRecordedVideosWatcher, saveProgramRecordedVideosWatcher, deleteProgramRecordedVideoWatcher, getClinicsForProgramWatcher, uploadSessionImageWatcher, createSessionWatcher, getAllSessionsWatcher, getSessionByIdWatcher, updateSessionWatcher, createMealsConfigurationWatcher, uploadMealsImageWatcher, getMealsUserWatcher, getMealsUserByIdWatcher, updateMealConfigurationByIdWatcher, uploadMenuItemImageWatcher, createMenuItemWatcher, checkAbhaExistsWatcher, verifyAbhaPhoneWatcher, verifyAbhaOtpWatcher, addAbhaWatcher, getAllAbhaCustomersWatcher, linkAbhaDocumentWatcher, getItemCategoriesWatcher, editCategoryWatcher, createCategoryWatcher, getItemProductsWatcher, getProductByIdWatcher, createCustomerWatcher, convertToLeadWatcher, getCarouselUrlsWatcher, uploadCarouselImageWatcher, deleteCarouselImageWatcher, getSocialLinksWatcher, getAboutUsWatcher, setAboutUsWatcher, deleteCustomerAccountWatcher, deleteUserAccountWatcher, uploadAboutUsImageWatcher, setSocialLinksWatcher, getDietComplianceWatcher, getDietPlanConfigWatcher, setDietPlanStartDateWatcher, setDietComplianceWatcher, getBookedSessionsByDateWatcher, changeSessionStatusWatcher, getMealOptionsWatcher, getMealManagementOrdersWatcher, getGuidelinesWatcher, setOrUpdateGuidelinesWatcher, getBookedSessionsByCustomerWatcher, getMenuItemByIdWatcher, updateMenuItemByIdWatcher, createHealthFeedWatcher, getAllHealthFeedWatcher, getHealthFeedByIdWatcher, deleteHealthFeedWatcher, updateHealthFeedWatcher, getListOfEnrollmentsWatcher, getEnrollmentResponseWatcher, getPromosWatcher, getCustomerPaymentsWatcher, getAllDietComplianceWatcher, getDocumentsWatcher, setDocumentWatcher, updateDocumentWatcher, deleteDocumentWatcher } from "../profile-customer";

export default function* customerProfile() {
    yield all([
        getCustFullProfileWatcher(),
        updateCustFullProfileWatcher(),
        getProgressSummaryWatcher(),
        getProgressHistoryWatcher(),
        updateProgressEntryWatcher(),
        deleteProgressEntryWatcher(),
        getMedicalHistoryWatcher(),
        updateMedicalHistoryWatcher(),
        getReportsWatcher(),
        deleteReportWatcher(),
        getFoodLifestyleWatcher(),
        updateFoodLifestyleWatcher(),
        getRecallWatcher(),
        updateRecallWatcher(),
        getActivityByDateWatcher(),
        setActivityGoalWatcher(),
        getFirstLastMeasureWatcher(),
        getAllMeasuresWatcher(),
        deleteMeasureByIdWatcher(),
        getBodyStartedCurrentWatcher(),
        getAllBodyMeasuresWatcher(),
        deleteBodyMeasureByIdWatcher(),
        getAllLeadsWatcher(),
        getAllCustomersWatcher(),
        getClustersWatcher(),
        getPractitionersWatcher(),
        getClinicsWatcher(),
        getTagsWatcher(),
        getCountriesWatcher(),
        getStatesWatcher(),
        getCitiesWatcher(),
        getCuisinesWatcher(),
        getDietWatcher(),
        uploadProgramImageWatcher(),
        uploadImageWatcher(),
        createProgramWatcher(),
        getProgramEnrolledUsersWatcher(),
        getSessionBookedUsersWatcher(),
        getCustomerFoodLogsWatcher(),
        getCustomerHistoryWatcher(),
        getProgramRecordedVideosWatcher(),
        saveProgramRecordedVideosWatcher(),
        deleteProgramRecordedVideoWatcher(),
        getClinicsForProgramWatcher(),
        uploadSessionImageWatcher(),
        createSessionWatcher(),
        getAllSessionsWatcher(),
        getSessionByIdWatcher(),
        updateSessionWatcher(),
        createMealsConfigurationWatcher(),
        uploadMealsImageWatcher(),
        getMealsUserWatcher(),
        getMealsUserByIdWatcher(),
        updateMealConfigurationByIdWatcher(),
        uploadMenuItemImageWatcher(),
        createMenuItemWatcher(),
        checkAbhaExistsWatcher(),
        verifyAbhaPhoneWatcher(),
        verifyAbhaOtpWatcher(),
        addAbhaWatcher(),
        getAllAbhaCustomersWatcher(),
        linkAbhaDocumentWatcher(),
        getItemCategoriesWatcher(),
        editCategoryWatcher(),
        createCategoryWatcher(),
        getItemProductsWatcher(),
        getProductByIdWatcher(),
        createCustomerWatcher(),
        convertToLeadWatcher(),
        getCarouselUrlsWatcher(),
        uploadCarouselImageWatcher(),
        deleteCarouselImageWatcher(),
        getSocialLinksWatcher(),
        getAboutUsWatcher(),
        setAboutUsWatcher(),
        deleteCustomerAccountWatcher(),
        deleteUserAccountWatcher(),
        uploadAboutUsImageWatcher(),
        setSocialLinksWatcher(),
        getDietComplianceWatcher(),
        getDietPlanConfigWatcher(),
        setDietPlanStartDateWatcher(),
        setDietComplianceWatcher(),
        getBookedSessionsByDateWatcher(),
        changeSessionStatusWatcher(),
        getMealOptionsWatcher(),
        getMealManagementOrdersWatcher(),
        getGuidelinesWatcher(),
        setOrUpdateGuidelinesWatcher(),
        getBookedSessionsByCustomerWatcher(),
        getMenuItemByIdWatcher(),
        updateMenuItemByIdWatcher(),
        createHealthFeedWatcher(),
        getAllHealthFeedWatcher(),
        getHealthFeedByIdWatcher(),
        deleteHealthFeedWatcher(),
        updateHealthFeedWatcher(),
        getListOfEnrollmentsWatcher(),
        getEnrollmentResponseWatcher(),
        getPromosWatcher(),
        getDocumentsWatcher(),
        setDocumentWatcher(),
        updateDocumentWatcher(),
        deleteDocumentWatcher(),
        getAllDietComplianceWatcher(),
        getCustomerPaymentsWatcher(),
    ])
}